import http from "../http-common";

class InventoryDataService {
    getAll(params = {}) {
        return http.get('/inventories', { params });
    }

    get(id) {
        return http.get(`/inventories/${id}`);
    }

    create(data) {
        const formData = new FormData();
        formData.append('product_id', data.product_id);
        if (data.location_id) {
            formData.append('location_id', data.location_id);
        }
        formData.append('type', data.type);
        // Ensure quantity is always a valid number
        const quantityStr = String(data.quantity || '').trim();
        const quantity = parseFloat(quantityStr);
        if (isNaN(quantity) || quantity <= 0) {
            throw new Error('Quantity must be a valid positive number');
        }
        formData.append('quantity', quantityStr);
        // Ensure unit_price is always a valid number
        const unitPriceStr = String(data.unit_price || '').trim();
        const unitPrice = parseFloat(unitPriceStr);
        if (isNaN(unitPrice) || unitPrice < 0) {
            throw new Error('Unit price must be a valid non-negative number');
        }
        formData.append('unit_price', unitPriceStr);
        if (data.origin_id) {
            formData.append('origin_id', data.origin_id);
        }
        if (data.provider_id) {
            formData.append('provider_id', data.provider_id);
        }
        if (data.buy_order_attachment) {
            formData.append('buy_order_attachment', data.buy_order_attachment);
        }
        if (data.notes) {
            formData.append('notes', data.notes);
        }
        if (data.transaction_date) {
            formData.append('transaction_date', data.transaction_date);
        }
        return http.post('/inventories', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    update(id, data) {
        const formData = new FormData();
        formData.append('_method', 'PUT'); // Laravel method spoofing for multipart/form-data
        formData.append('product_id', data.product_id);
        if (data.location_id) {
            formData.append('location_id', data.location_id);
        }
        formData.append('type', data.type);
        // Ensure quantity is always a valid number
        const quantityStr = String(data.quantity || '').trim();
        const quantity = parseFloat(quantityStr);
        if (isNaN(quantity) || quantity <= 0) {
            throw new Error('Quantity must be a valid positive number');
        }
        formData.append('quantity', quantityStr);
        // Ensure unit_price is always a valid number
        const unitPriceStr = String(data.unit_price || '').trim();
        const unitPrice = parseFloat(unitPriceStr);
        if (isNaN(unitPrice) || unitPrice < 0) {
            throw new Error('Unit price must be a valid non-negative number');
        }
        formData.append('unit_price', unitPriceStr);
        if (data.origin_id) {
            formData.append('origin_id', data.origin_id);
        }
        if (data.provider_id) {
            formData.append('provider_id', data.provider_id);
        }
        if (data.buy_order_attachment) {
            formData.append('buy_order_attachment', data.buy_order_attachment);
        }
        if (data.notes) {
            formData.append('notes', data.notes);
        }
        if (data.transaction_date) {
            formData.append('transaction_date', data.transaction_date);
        }
        // Use POST with _method=PUT for multipart/form-data (Laravel best practice)
        return http.post(`/inventories/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    delete(id) {
        return http.delete(`/inventories/${id}`);
    }

    getStatistics(params = {}) {
        return http.get('/inventories-statistics', { params });
    }
}

export default new InventoryDataService();
